// ============================================================================
// SWAHILI TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Maswali ya kufurahisha lakini ya kutafakari

export const funQuestions = [
  {
    question: "Kama Yesu angekuwa na simu, nani angekuwa mwasiliani wake wa kwanza?",
    emoji: "📱",
    theme: "uhusiano_wa_kimungu"
  },
  {
    question: "Kwa nini Daudi hakuwahi kupoteza kondoo wake?",
    emoji: "🐑", 
    theme: "mchungaji"
  },
  {
    question: "Upendo wa Mungu unagharimu kiasi gani?",
    emoji: "💰",
    theme: "neema"
  },
  {
    question: "Je, kuna tofauti gani kati ya amani ya Mungu na usingizi?",
    emoji: "😴",
    theme: "amani"
  },
  {
    question: "Kwa nini Neno la Mungu halipungui betri kamwe?",
    emoji: "🔋",
    theme: "neno"
  },
  {
    question: "Kama Musa angekuwa na GPS, angepotea miaka 40 jangwani?",
    emoji: "🗺️",
    theme: "uongozi"
  },
  {
    question: "Kwa nini malaika hawahitaji kufanya mazoezi kamwe?",
    emoji: "👼",
    theme: "ukamilifu"
  },
  {
    question: "Sulemani angesema nini kuhusu mitandao ya kijamii ya kisasa?",
    emoji: "📱",
    theme: "hekima"
  }
];

export default funQuestions;
